export const MACHINES = "MACHINES";
export const ENTERPRISES_TYPES = "ENTERPRISES_TYPES";
export const CREATE_MACHINE = "CREATE_MACHINE";

export const CREATE_BRAND = "CREATE_BRAND";
export const CREATE_TYPE = "CREATE_TYPE";
export const CREATE_LEGALENTITIES = "CREATE_LEGALENTITIES";


export const CREATE_MACHINE_CE = "CREATE_MACHINE_CE";

export const SINGLE_MACHINE = "SINGLE_MACHINE";
export const SINGLE_MACHINE_CE = "SINGLE_MACHINE_CE";

export const INTERNAL_ATTACHMENTS = "INTERNAL_ATTACHMENTS";
export const MANUFACTURER_ATTACHMENTS = "MANUFACTURER_ATTACHMENTS";


export const MACHINES_IMAGES = "MACHINES_IMAGES";

export const CREATE_MACHINE_POOL = "CREATE_MACHINE_POOL";

export const GET_MACHINE_POOLS_OF_USER = "GET_MACHINE_POOLS_OF_USER";


export const GET_MACHINES_OF_POOL = "GET_MACHINES_OF_POOL";

export const CREATE_FAQ = "CREATE_FAQ";
export const UPDATE_FAQ = "UPDATE_FAQ";
export const DELETE_FAQ = "DELETE_FAQ";

export const CREATE_MAINTENANCE_TASK = "CREATE_MAINTENANCE_TASK";
export const MAINTENANCE_TASK_TEMPLATES = "MAINTENANCE_TASK_TEMPLATES";

export const DELETE_MAINTENANCE_TASK_TEMPLATE = "DELETE_MAINTENANCE_TASK_TEMPLATE";


export const UPDATE_MAINTENANCE_TASK = "UPDATE_MAINTENANCE_TASK";


export const UPDATE_MACHINE_POOL = "UPDATE_MACHINE_POOL";
export const UPDATE_MACHINE = "UPDATE_MACHINE";
export const DELETE_MACHINE = "DELETE_MACHINE";

export const UPDATE_MACHINE_CE = "UPDATE_MACHINE_CE";
export const DELETE_MACHINE_CE = "DELETE_MACHINE_CE";

export const UPDATE_MACHINE_DOCUMENT = "UPDATE_MACHINE_DOCUMENT";
export const DELETE_MAINTENANCE_TASK = "DELETE_MAINTENANCE_TASK";


export const DELETE_MACHINE_POOL = "DELETE_MACHINE_POOL";

export const GET_LEGAL_ENTITIES = "GET_LEGAL_ENTITIES";

// export const COPILOT_QUERRY = "COPILOT_QUERRY";


// export const initiateCopilotQuery = data => {
//   return {
//     type: COPILOT_QUERRY,
//     payload:data
//   };
// }


export const getLegalEntities = (op) =>{
  return {
    type: GET_LEGAL_ENTITIES,
    optype:op
  };
};

export const getall = () =>{
  return {
    type: MACHINES
  };
};
export const getSingleMachine = data =>{
  return {
    type: SINGLE_MACHINE,
    payload:data
  };
};

export const getenterpriseswithtypes = () =>{
  return {
    type: ENTERPRISES_TYPES
  };
};

export const createmachine = data =>{
  return {
    type: CREATE_MACHINE,
    payload:data
  };
};


export const createLegalEntity = data =>{
  return {
    type: CREATE_LEGALENTITIES,
    payload:data
  };
};

export const createBrand = data =>{
  return {
    type: CREATE_BRAND,
    payload:data
  };
};


export const createType = data =>{
  return {
    type: CREATE_TYPE,
    payload:data
  };
};


export const updatemachine = data =>{
  return {
    type: UPDATE_MACHINE,
    payload:data
  };
};

export const deletemachine = data =>{
  return {
    type: DELETE_MACHINE,
    payload:data
  };
};
export const updatemachinedocument = data =>{
  return {
    type: UPDATE_MACHINE_DOCUMENT,
    payload:data
  };
};

export const createmachineCE = data =>{
  return {
    type: CREATE_MACHINE_CE,
    payload:data
  };
};
export const updatemachineCE = data =>{
  return {
    type: UPDATE_MACHINE_CE,
    payload:data
  };
};

export const deletemachineCE = data =>{
  return {
    type: DELETE_MACHINE_CE,
    payload:data
  };
};

export const createmachinePool = data =>{
  return {
    type: CREATE_MACHINE_POOL,
    payload:data
  };
};

export const updatemachinePool = data =>{
  return {
    type: UPDATE_MACHINE_POOL,
    payload:data
  };
};

export const deletemachinePool = data =>{
  return {
    type: DELETE_MACHINE_POOL,
    payload:data
  };
};

export const getMachinePoolsofUser = (data,op) =>{
  return {
    type: GET_MACHINE_POOLS_OF_USER,
    payload:data,
    optype:op
  };
};
export const getMachinesofPool = (data,op) =>{
  return {
    type: GET_MACHINES_OF_POOL,
    payload:data,
    optype:op
  };
};

export const getinternalattachments = data =>{
  return {
    type: INTERNAL_ATTACHMENTS,
    payload:data
  };
};
export const getmanufacturerattachments = data =>{
  return {
    type: MANUFACTURER_ATTACHMENTS,
    payload:data
  };
};

export const getMachinesImages = data =>{
  return {
    type: MACHINES_IMAGES,
    payload:data
  };
};

export const CreateFaq = data =>{
  return {
    type: CREATE_FAQ,
    payload:data
  };
};

export const UpdateFaq = data =>{
  return {
    type: UPDATE_FAQ,
    payload:data
  };
};
export const DeleteFaq = data =>{
  return {
    type: DELETE_FAQ,
    payload:data
  };
};

export const CreateMaintenanceTask = data =>{
  return {
    type: CREATE_MAINTENANCE_TASK,
    payload:data
  };
};


export const getAllMaintenanceTaskTemplates = (op) =>{
  return {
    type: MAINTENANCE_TASK_TEMPLATES,
    optype:op
  };
};

export const deleteMaintenanceTaskTemplate = (nodeid,op) =>{
  return {
    type: DELETE_MAINTENANCE_TASK_TEMPLATE,
    payload: nodeid,
    optype:op
  };
};

export const UpdateMaintenanceTask = data =>{
  return {
    type: UPDATE_MAINTENANCE_TASK,
    payload:data
  };
};

export const DeleteMaintenanceTask = data =>{
  return {
    type: DELETE_MAINTENANCE_TASK,
    payload:data
  };
};